import { Modal } from "d-react-components";
import { useFormik } from "formik";
import Messages from "../../../languages/Messages";
import BookingFilterForm from "../common/BookingFilterForm";

interface IBookingTableFilterModal {
    open: boolean;
    defaultValue: any;
    onClose: () => void;
    onFilter: (values: any) => void;
}

function BookingFilterModal({
    open,
    defaultValue = {},
    onClose,
    onFilter,
}: IBookingTableFilterModal) {
    const filterForm = useFormik<any>({
        initialValues: defaultValue as any,
        validateOnChange: false,
        validateOnBlur: false,
        onSubmit: (values: any) => {
            onFilter(values);
            onClose();
        },
    });

    return (
        <Modal
            open={open}
            onClose={onClose}
            title={Messages.filter}
            onSave={() => filterForm.handleSubmit()}
            size="medium"
            sideText={Messages.clearAll}
            onSideClick={() => filterForm.setValues({})}
        >
            <BookingFilterForm filterForm={filterForm} />
        </Modal>
    );
}

export default BookingFilterModal;
